module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-6.339f1191.svg";